export const DOBROKOMUNITA_SLUG = 'dobrokomunita'
export const SGN_SLUG = 'sgn'

export const DOBRO_CUSTOM_FIELDS = {
    representedOrganizations: 'representedOrganizationIds',
    representedOrganizationText: 'representedOrganizationText',
    organizationTopics: 'organizationTopics'
} as const
